import React, { useRef, useContext } from 'react';
import PropTypes from 'prop-types';

import DatePickerDesktop from './Desktop';
import DatePickerMobile from './Mobile';
import { MediaContext } from '@spa/shared/contexts/media';
import { DATE_FORMAT, toDate } from '@spa/shared/utils/transformers/contracts';
import { useDateRangeWithoutInputs } from '@spa/shared/hooks/dateRange/without-input';
import { getMaxMoveInDate } from '@spa/shared/utils/availabilities';
import { CalendarContext } from '@spa/shared/contexts/calendar';
import { isDateBlocked } from '@spa/shared/utils/availabilities/availabilities';

const DEFAULT_MINIMUM_DAY_GAP = 27;
const MONTHS_TO_SHOW = {
  mobile: 24,
  desktop: 2
};

const DatePicker = ({
  guests,
  maxGuests,
  setGuests,
  firstPayment,
  referencePrice,
  minimumStay,
  maximumStay,
  availableFrom,
  moveIn,
  moveOut,
  setMoveInOut,
  classNames = {},
  blockedDates = [],
  rents = [],
  availabilityRules = [],
  availablePeriods = []
}) => {
  const { is } = useContext(MediaContext);
  const { validateDates } = useContext(CalendarContext);
  const ref = useRef();

  const dateRange = useDateRangeWithoutInputs(
    ref,
    moveIn,
    moveOut,
    'moveIn',
    'moveOut',
    ({ moveIn, moveOut }) => setMoveInOut(moveIn, moveOut),
    (moveIn && toDate(moveIn, DATE_FORMAT)) || availableFrom,
    validateDates,
    minimumStay || DEFAULT_MINIMUM_DAY_GAP,
    0,
    is.mobile ? MONTHS_TO_SHOW.mobile : MONTHS_TO_SHOW.desktop,
    date => isDateBlocked(date, blockedDates, availablePeriods),
    getMaxMoveInDate(availableFrom, availabilityRules)
  );

  return is.mobile ? (
    <DatePickerMobile
      firstPayment={firstPayment}
      referencePrice={referencePrice}
      guests={guests}
      maxGuests={maxGuests}
      setGuests={setGuests}
      moveIn={moveIn}
      moveOut={moveOut}
      dateRange={dateRange}
      classNames={classNames}
      rents={rents}
    />
  ) : (
    <DatePickerDesktop
      guests={guests}
      maxGuests={maxGuests}
      setGuests={setGuests}
      moveIn={moveIn}
      moveOut={moveOut}
      dateRange={dateRange}
      firstPayment={firstPayment}
      referencePrice={referencePrice}
      maximumStay={maximumStay}
      rents={rents}
    />
  );
};

DatePicker.propTypes = {
  guests: PropTypes.number,
  maxGuests: PropTypes.number,
  setGuests: PropTypes.func,
  firstPayment: PropTypes.object,
  referencePrice: PropTypes.object,
  minimumStay: PropTypes.number,
  maximumStay: PropTypes.number,
  availableFrom: PropTypes.string,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string,
  setMoveInOut: PropTypes.func,
  classNames: PropTypes.object,
  blockedDates: PropTypes.array,
  rents: PropTypes.array,
  availabilityRules: PropTypes.array,
  availablePeriods: PropTypes.array
};

export default DatePicker;
